import React from "react";
import "./BonusProgress.css";

const BonusProgress = ({ savedUser }) => {
  const bonuses = savedUser?.user_bonuses ?? 5000;
  console.log(savedUser);
  const levels = savedUser.user_loyalty_system;

  const currentLevel = levels
    .slice()
    .reverse()
    .find((level) => bonuses >= level.threshold);

  const nextLevel = levels.find((level) => level.threshold > bonuses);
  const pointsToNext = nextLevel ? nextLevel.threshold - bonuses : 0;

  const progressIndex = levels.findIndex(
    (l) => l.percentage === currentLevel.percentage
  );
  const totalSteps = levels.length - 1;
  const progressPercent =
    (progressIndex / totalSteps) * 100 +
    (nextLevel
      ? ((bonuses - currentLevel.threshold) /
          (nextLevel.threshold - currentLevel.threshold)) *
        (100 / totalSteps)
      : 0);

  return (
    <div className='bonus-card'>
      <div className='bonus-header__title'>
        <div className='bonus-title'>Накопленные баллы</div>

        <div className='bonus-amount'>{bonuses}Б</div>
      </div>
      <div className='bonus-header'>
        <div>
          <p className='bonus-sub m-0'>
            Кэшбек {currentLevel.percentage}% с каждого заказа
          </p>
        </div>
      </div>

      <div className='bonus-progress'>
        <div className='bonus-line'></div>
        <div
          className='bonus-line-active'
          style={{ width: `${progressPercent}%` }}
        ></div>
        {levels.map((level, index) => {
          const isActive = bonuses >= level.threshold;
          const isCurrent = currentLevel.percentage === level.percentage;
          return (
            <div
              key={index}
              className='bonus-level'
              style={{
                left: `${(index / (levels.length - 1)) * 100}%`,
              }}
            >
              <div
                className={`bonus-circle ${
                  isCurrent ? "current" : isActive ? "active" : ""
                }`}
              ></div>
              <span className='bonus-label'>{level.percentage}%</span>
            </div>
          );
        })}
      </div>

      {nextLevel && (
        <p className='bonus-next m-0'>
          до следующего уровня не хватает {pointsToNext.toLocaleString()} Б
        </p>
      )}
    </div>
  );
};

export default BonusProgress;
